import { render } from "./ModalProductDetails.vue?vue&type=template&id=06dcf60d&scoped=true&ts=true"
import script from "./ModalProductDetails.vue?vue&type=script&lang=ts"
export * from "./ModalProductDetails.vue?vue&type=script&lang=ts"

import "./ModalProductDetails.vue?vue&type=style&index=0&id=06dcf60d&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06dcf60d"]])

export default __exports__